/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'overview': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M29.5 35a.501.501 0 0 1-.5-.5v-5c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5v5c0 .275-.225.5-.5.5h-5zm-8 0a.501.501 0 0 1-.5-.5v-5c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5v5c0 .275-.225.5-.5.5h-5zm-8 0a.501.501 0 0 1-.5-.5v-5c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5v5c0 .275-.225.5-.5.5h-5zm16-8a.501.501 0 0 1-.5-.5v-5c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5v5c0 .275-.225.5-.5.5h-5zm-8 0a.501.501 0 0 1-.5-.5v-5c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5v5c0 .275-.225.5-.5.5h-5zm-8 0a.501.501 0 0 1-.5-.5v-5c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5v5c0 .275-.225.5-.5.5h-5zm16-8a.501.501 0 0 1-.5-.5v-5c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5v5c0 .275-.225.5-.5.5h-5zm-8 0a.501.501 0 0 1-.5-.5v-5c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5v5c0 .275-.225.5-.5.5h-5zm-8 0a.501.501 0 0 1-.5-.5v-5c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5v5c0 .275-.225.5-.5.5h-5z" fill-rule="evenodd" clip-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/overview.js